<h1 mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    Create Campaign
</h1>

<mat-dialog-content>
    <div class="container-fluid p-2" [formGroup]="outboundCampaignForm">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Campaign Name</mat-label>
                    <mat-error>Name is required</mat-error>
                    <input type="text" matInput formControlName="campaignName">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <mat-form-field class="w-100">
                    <mat-label>Choose a date</mat-label>
                    <mat-error>The scheduled date is required</mat-error>
                    <input formControlName="date" matInput [matDatepicker]="picker" required>
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-4">
                <mat-form-field class="w-100">
                    <mat-error>The scheduled date is required</mat-error>
                    <input formControlName="time" matInput [ngxMatTimepicker]="timePicker" required
                        placeholder="12:00 AM">
                    <ngx-mat-timepicker #timePicker></ngx-mat-timepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Timezone</mat-label>
                <mat-error *ngIf="outboundCampaignForm.controls['timezone'].hasError('required')">You need to enter your timezone</mat-error>
                <mat-error *ngIf="outboundCampaignForm.controls['timezone'].hasError('timezone')">timezone is not valid</mat-error>
                <input matInput placeholder="Ex: America/New_York" formControlName="timezone" [matAutocomplete]="auto" required>
                <mat-autocomplete #auto="matAutocomplete">
                    @for (option of filteredOptions | async; track option) {
                      <mat-option [value]="option">{{option}}</mat-option>
                    }
                  </mat-autocomplete>
                <mat-hint>Enter the time zone</mat-hint>
            </mat-form-field>
        </div>
        <div class="row mt-4">
            <button (click)="f_input.click()" mat-raised-button type="button">
                <span>Upload Excel file</span>
                <mat-icon>upload</mat-icon>
            </button>
            <input multiple hidden #f_input type="file"
                accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                (change)="handleFileInputChange(f_input.files!)">
        </div>
    </div>
</mat-dialog-content>

<p class="text-danger text-center" *ngIf="errorMessage">{{errorMessage}}</p>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" color="warn" [disabled]="isLoading">Close</button>
    <button mat-raised-button class="w-25" [disabled]="isLoading || !outboundCampaignForm.valid || !fileSet" (click)="onSubmitForm()" color="primary">
        <span *ngIf="!isLoading">
            {{isEditing ?'Save' : 'Add'}}
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>